<!--
 * @Author: dgq 370541946@qq.com
 * @Date: 2025-05-13 17:12:37
 * @FilePath: /insuranceagent-ui/src/components/insurance/productChoice.vue
 * @Description: 产品选择
-->
<template>
	<el-dialog :visible.sync="isShowProductChoice" center title="选择产品" top="18vh" width="60%" @close="onClose">
		<div style="display: flex; justify-content: center; padding: 20px 20px 40px">
			<el-card
				v-for="(item, index) in productList"
				:key="index"
				:body-style="{padding: '20px'}"
				style="margin: 10px; width: 450px">
				<el-row justify="center" type="flex">
					<div style="font-size: 1.2em; font-weight: bold; height: 70px" v-html="item.pubName"></div>
				</el-row>

				<el-row justify="center" type="flex" align="center">
					<div>
						<span style="font-size: 1.1em; font-weight: bold" v-html="item.description"></span>
						<div v-if="item.pubPrice">
							<span style="font-size: 1.3em; font-weight: bold; color: #ff4500">￥{{ item.pubPrice }} 起</span>
						</div>
					</div>
				</el-row>

				<!-- <el-row justify="center" style="margin-top: 10px" type="flex">
					<ul style="font-size: 0.75em; padding-left: 0; list-style-type: none">
						<li>{{ item.describes[0] }}</li>
						<li>{{ item.describes[1] }}</li>
						<li>{{ item.describes[2] }}</li>
					</ul>
				</el-row> -->

				<el-row style="margin-top: 30px" justify="center" type="flex">
					<el-button type="primary" plain @click="handleDetail(item)">查看详情</el-button>
					<el-button type="primary" @click="handleInsure(item)">立即投保</el-button>
				</el-row>
			</el-card>
		</div>
	</el-dialog>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

export default {
	name: 'productChoice',
	mixins: [],
	components: {},
	props: {
		productList: {
			required: true,
			defaults: () => {
				return []
			},
		},
		isShowProductChoiceTemp: {
			type: Boolean,
			defaults: false,
		},
	},
	data() {
		return {
			isShowProductChoice: this.isShowProductChoiceTemp,
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
	},
	watch: {
		isShowProductChoiceTemp(newVal, oldVal) {
			this.isShowProductChoice = newVal
		},
	},
	methods: {
		handleDetail(itemData) {
			let {productId, sourceProductId} = itemData
			this.$router.push({
				path: this.$router.$avueRouter.getPath({
					src: `/insuranceCenter/detailsCenter/1`,
				}),
				query: {
					productId: sourceProductId,
					productIdCenter: productId,
				},
			})
			this.$emit('onClickClose')
		},
		handleInsure(itemData) {
			// let {sourceProductId, productId = ''} = itemData
			// let tempData = {productType: sourceProductId}
			// if (productId) {
			// 	tempData.productId = productId
			// }
			this.$emit('onClickInsure', itemData)
		},
		onClose() {
			//发送关闭数据
			this.$emit('onClickClose')
		},
	},
	created() {},
	mounted() {},
}
</script>

<style lang="scss" scoped>
.product_content {
	//padding: 10px;
	//border-radius: 1;
	//border: 1px solid rgb(234, 234, 234);
}
</style>
